import {
  FormControl,
  FormHelperText,
  FormLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { IQuestion, IQuestionOptions } from "../../interfaces";
import { useState } from "react";
import RenderQuestion from "../RenderQuestion";
import { SelectInputProps } from "@mui/material/Select/SelectInput";
import {nanoid} from "nanoid";
import { Controller, useFormContext } from "react-hook-form";
import React from "react";
import { useApp } from "../../Contexts/AppProvider";


interface IProps extends IQuestion {
  selectProps?: Partial<SelectInputProps & {placeholder: string}>
}
export default function QuestionSelectInput({
  index: indexQuestion,
  question,
  type,
  options,
  fieldNameVoucher,
  mask,
  description,
  defaultValue,
  hasTree,
  selectProps
}: IProps) {
  const {onSetCurrentQuestions} = useApp();
  const { control, setValue, clearErrors } = useFormContext();
  const [otherQuestion, setOtherQuestion] = useState<IQuestion[]>([]);

  const keySelect = nanoid();

  React.useEffect(() => {
    onSetCurrentQuestions({
      index: indexQuestion,
      question,
      type,
      options,
      fieldNameVoucher,
      mask,
      description,
      defaultValue,
      hasTree,
    });

    return () => {
      onSetCurrentQuestions({
        index: indexQuestion,
        question,
        type,
        options,
        fieldNameVoucher,
        mask,
        description,
        defaultValue,
        hasTree,
      }, true);
    }
  }, [
    defaultValue,
    description,
    hasTree,
    indexQuestion,
    mask,
    onSetCurrentQuestions,
    options,
    question,
    type,
    fieldNameVoucher
  ])

  return (
    <>
      <Controller
        name={indexQuestion}
        control={control}
        defaultValue={"-1"}
        render={({ field: {value, name, ref}, formState: {errors} }) => {
          return (
            <FormControl
              sx={{mt: 1, mb: 2}}
              fullWidth
              error={!!errors[indexQuestion]?.message}
              focused={!!errors[indexQuestion]?.message}
            >
              <FormLabel id={`${keySelect}-select-label`}>{question}</FormLabel>
              <Select
                sx={{mt: 1}}
                required
                ref={ref}
                name={name}
                value={value}
                labelId={`${keySelect}-select-label`}
                id={`${keySelect}-select`}
                onChange={(e, _) => {
                  clearErrors(indexQuestion);
                  setValue(indexQuestion, e.target.value);
                  const optSelected = options?.find((opt: IQuestionOptions) => opt.value === e.target.value);
                  setOtherQuestion(optSelected?.questions as IQuestion[] || []);
                  selectProps?.onChange && selectProps?.onChange(e, _);
                }}
              >
                <MenuItem value={"-1"} disabled={true}><em style={{color: '#999'}}>{selectProps?.placeholder || 'Selecionar'}</em></MenuItem>
                {options?.map(({value}: any) => {
                  const keyOptions = nanoid();
                  return (
                    <MenuItem key={`${keyOptions}-select-options`} value={value}>
                      {value}
                    </MenuItem>
                  )
                })}
              </Select>
              {(description || errors[indexQuestion]?.message) && (
                <FormHelperText>{description || errors[indexQuestion]?.message as string}</FormHelperText>
              )}
            </FormControl>
          )
        }}
      />
      {otherQuestion?.map((props) => <RenderQuestion key={props?.index?.toString()} {...props} />)}
    </>
  )
}